// Copyright 2018 OpaVote LLC.  All rights reserved.

'use strict';

// Prevent double form submissions
$(document).ready(function() {
  $('form').submit(function() {
    if (this.beenSubmitted)
      return false;
    else
      this.beenSubmitted = true;
  });
});

// Google analytics
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');

// Set a virtual path to make analytics more useful
var path = globalThis.path = window.location.pathname;
path = path.replace(/[0-9]+.*/, '');
var status = globalThis.status = $('#data').data('status');
var payments = globalThis.payments = $('#data').data('payments');
if (path == '/payments' && Number(payments) > 0) path = '/payments/customer';
if (path == '/manage/') path += status.toLowerCase();

ga('create', 'UA-9453549-3', 'auto');
ga('set', 'page', path);
ga('send', 'pageview');

// Newsletter pop up
globalThis.newsletter = function newsletter() {
  $('.close').click(function() {
    $('#subscribe-form').alert('close');
  });
  $('#subscribe-form').on('closed.bs.alert', function() {
    var exp = new Date();
    exp.setDate(exp.getDate() + 7);
    document.cookie = 'newsletter=true; expires=' + exp.toUTCString();
  });
}

// Dialog shortcuts
var opavote_dlg = globalThis.opavote_dlg = (function() {

  var my = {};

  my.dlg = function(size, msg, title, buttons, options, focused) {
    if (typeof title === 'undefined') title = 'OpaVote Message';
    if (typeof options === 'undefined') more_options = {show: true};
    if (typeof focused === 'undefined') focused = '.btn-default';
    var html = '<div id="dynamic-modal" class="modal fade">' +
               '<div class="modal-dialog ' + size + '">' +
               '<div class="modal-content">' +
               '<div class="modal-header">';
    html += '<button type="button" class="close" data-dismiss="modal">' +
            '<span class="glyphicon glyphicon-remove"></span></button>';
    html += '<h4 class="modal-title">' + title + '</h4>' +
            '</div>' +
            '<div class="modal-body">' + msg + '</div>';
    if (typeof buttons != 'undefined') {
      html += '<div class="modal-footer">';
      for (var b in buttons) {
        html += '<button type="button" ' + buttons[b] + '>';
        if (b == 'Cancel' || b == 'Go Back') {
          html += '<span class="glyphicon glyphicon-remove"></span> ';
        }
        if (b == 'Confirm' || b == 'OK') {
          html += '<span class="glyphicon glyphicon-ok"></span> ';
        }
        html += b + '</button>';
      }
      html += '</div>';
    }
    html += '</div></div></div>';
    var $msg_dlg = $(html).modal(options);
    $msg_dlg.on('shown.bs.modal', function() {
      $msg_dlg.find(focused).focus() });
    $msg_dlg.on('hidden.bs.modal', function() { $msg_dlg.remove() });
    // Return the dlg so it can be removed via code (e.g., to show
    // another dialog).
    return $msg_dlg;
  };

  my.msg_sm = function(msg, title) { return my.dlg('modal-sm', msg, title) };

  my.msg_md = function(msg, title) { return my.dlg('', msg, title) };

  my.msg_lg = function(msg, title) { return my.dlg('modal-lg', msg, title) };

  my.confirm_vote = function(event, html, title, confirm_btn, cancel_btn) {
    if (event.originalEvent) {
      var $button = $(event.target);
      event.preventDefault();
      // Buttons to show
      var buttons = {};
      buttons[cancel_btn] = 'class="btn btn-default" data-dismiss="modal"';
      buttons[confirm_btn] = 'class="btn btn-primary" id="confirm-btn"';
      // Now show the dialog and add callbacks
      var $dlg = my.dlg('', html, title, buttons);
      $dlg.on('click', '#confirm-btn', function() {
        $dlg.modal('hide');
        $button.click();
      });
      return false;
    }
  };

  return my;
}());

//
// Manage election/poll pages
//

var account = globalThis.account = (function() {

  var my = {};

  my.init = function() {
    // Button to show/hide secret key
    $('#key-link').hide();
    var $b = $('#key-button');
    $b.click(function() {
      $('#key-link').toggle();
      $b.text($b.text() === 'Show' ? 'Hide' : 'Show');
    });
  };

  return my;
}());

var set_locale = globalThis.set_locale = (function() {

  var my = {};

  my.init = function() {

    // Set select box to match locale of page
    var locale = $('#data-locale').data('locale');
    $('#locale select option[value="' + locale + '"]')
      .prop('selected', true);
    // When user selects a different locale, set locale cookie and reload.
    $('#locale select').change(function() {
      var exp = new Date();
      exp.setDate(exp.getDate() + 30);
      locale = $('#locale option:selected').val();
      document.cookie = 'locale=' + locale + '; ' +
                        'expires=' + exp.toUTCString() + '; ' +
                        'path=/;';
      location.reload(true);
    });
 };

  return my;
}());

var compute_price = globalThis.compute_price = (function() {

  var my = {};

  function _round_up_10(price) {
    q = Math.floor(price / 10);
    r = price % 10;
    price = q * 10 + (r ? 10 : 0);
    return Math.round(price);
  }

  function update_price() {
    var item = $('#item-btns .btn-success').attr('id');

    var voters = $('#voters').val();
    var voters_price;
    if (item === 'poll-btn' || voters <= 25) {
      voters_price = 0;
    } else {
      voters_price = (voters / 12.5);
    }

    var candidates = $('#candidates').val();
    var candidates_price;
    if (candidates <= 10) {
      candidates_price = 0;
    } else {
      candidates_price = candidates / 2.0;
    }

    var price = Math.max(voters_price, candidates_price);
    var price = _round_up_10(price);

    $('#price').text(price);
  }

  function change_item(event) {
    $('#item-btns button').removeClass('btn-success');
    $('#item-btns button').addClass('btn-default');
    var btn = $(event.target);
    btn.addClass('btn-success');
    btn.removeClass('btn-default');
    if (btn.attr('id') === 'poll-btn') {
      $('#unlimited').show();
      $('#voters').hide();
    } else {
      $('#unlimited').hide();
      $('#voters').show();
    }
    update_price();
  }

  my.init = function() {
    $('#unlimited').hide();
    $('#item-btns button').on('click', change_item);
    $('#weeks').on('input', update_price);
    $('#voters').on('input', update_price);
    $('#candidates').on('input', update_price);
    // Fix height of voters paragraph
    var $p = $('#voters').parent();
    $p.height($p.height());
    // Initialize the price
    update_price();
  };

  return my;
}());

var manage_editing = globalThis.manage_editing = (function() {

  var my = {};
  var eid;
  var $start_dlg;

  function _show_hide_form_fields($contest, method, ballot_type) {
    if (method === 'Approval Voting') {
      // Hide both ballot type (always choose one) and require full
      // (there is no 'full' for approval).
      $contest.find('[id$="-ballot_type"]').parent().parent().slideUp();
      $contest.find('[id$="-require_full"]').parent().parent().slideUp();
    } else if (method === 'Plurality/FPTP/SNTV' ||
               method === 'Plurality at Large/Block Voting/MNTV') {
      // Hide ballot type (always choose one) but show require full.
      $contest.find('[id$="-ballot_type"]').parent().parent().slideUp();
      $contest.find('[id$="-require_full"]').parent().parent().slideDown();
    } else {
      // This is for all ranked methods.  Always show ballot type.  Show
      // require full only for a ranked enhanced ballot type.
      $contest.find('[id$="-ballot_type"]').parent().parent().slideDown();
      if (ballot_type === 'ranked enhanced') {
        $contest.find('[id$="-require_full"]').parent().parent().slideDown();
      } else {
        $contest.find('[id$="-require_full"]').parent().parent().slideUp();
      }
    }
  }

  function method_select_update(event) {
    var $contest = $(event.delegateTarget);
    var method = $(event.target).val();
    var ballot_type = $contest.find('[id$="-ballot_type"]').val();
    _show_hide_form_fields($contest, method, ballot_type);
  }

  function ballot_type_select_update(event) {
    var $contest = $(event.delegateTarget);
    var ballot_type = $(event.target).val();
    var method = $contest.find('[id$="-method"]').val();
    _show_hide_form_fields($contest, method, ballot_type);
  }

  function process_tab_click(event) {
    var current_tab_name = $('#tab').val();
    var clicked_tab = $(event.delegateTarget);
    var new_tab_name = clicked_tab.children().first().attr('href').substr(1);
    // Save tab name so it can shown after form submission
    $('#tab').val(new_tab_name);
    // Save if clicking away from info tab
    if (current_tab_name === 'info' && $('#manage').data('changed')) {
      $('button[value="save"]:first').click(); // two save buttons!
    }
  }

  my.init = function() {
    eid = $('#data-eid').data('eid');
    // disable separators in select boxes
    $('[value^="\u2550"]').attr('disabled', true);
    // detect selection of method  and ballot type so we can update contest form
    $('.edit-contest').each(function() {
      var $contest = $(this);
      var method = $contest.find('[id$="-method"]').val();
      var ballot_type = $contest.find('[id$="-ballot_type"]').val();
      _show_hide_form_fields($contest, method, ballot_type);
      $contest.on('change', '[id$="-method"]', method_select_update);
      $contest.on('change', '[id$="-ballot_type"]', ballot_type_select_update);
    });
    // date pickers
    $('#manage_start_date').datepicker({minDate: 0, maxDate: 7});
    $('#manage_stop_date').datepicker({minDate: 0});
    // email ajax uploading
    $('#email-upload').fileupload({
      url: '/ajax/' + eid + '/set-emails',
      dataType: 'json',
      maxNumberOfFiles: 1,
      maxFileSize: 10000000,
      formAcceptCharset: 'utf-8',
      start: function(e) {
        $start_dlg = opavote_dlg.msg_sm(
          'Processing voter list. Please wait for confirmation.');
      },
      done: function(e, data) {
        // Show an error message`
        if (data.result.error) {
          $start_dlg.modal('hide');
          $('#progress .progress-bar').css('width', 0 + '%');
          opavote_dlg.msg_sm(data.result.msg);
        // Save the page so we can present updated info
        } else {
          $('button[value="save"]:first').click();
        }
      },
      progressall: function(e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        $('#progress .progress-bar').css('width', progress + '%');
      }
    });
    // weight ajax uploading
    $('#weight-upload').fileupload({
      url: '/ajax/' + eid + '/set-weights',
      dataType: 'json',
      maxNumberOfFiles: 1,
      maxFileSize: 10000000,
      formAcceptCharset: 'utf-8',
      start: function(e) {
        $start_dlg = opavote_dlg.msg_sm(
          'Processing weights. Please wait for confirmation.');
      },
      done: function(e, data) {
        // Show an error message`
        if (data.result.error) {
          $start_dlg.modal('hide');
          $('#progress .progress-bar').css('width', 0 + '%');
          opavote_dlg.msg_sm(data.result.msg);
        // Save the page so we can present updated info
        } else {
          $('button[value="save"]:first').click();
        }
      },
      progressall: function(e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        $('#progress .progress-bar').css('width', progress + '%');
      }
    });
    // track form changes for auto saving in process_tab_click
    $('#manage :input').change(function() {
      $('#manage').data('changed', true);
    });
    // set tab based on hidden form field
    var tab_name = $('#tab').val();
    $('a[href="#' + tab_name + '"]').tab('show');
    // Save tab on tab click and autosave if needed
    $('ul.nav-tabs li').click(process_tab_click);
  };

  return my;
}());

var manage_voting = globalThis.manage_voting = (function() {

  var my = {};
  var eid;

  function show_email_txt_editor() {
    $('#edit-preview-btns').slideUp();
    $('#email-txt-editor').slideDown();
  }

  function email_txt_editor_cancel() {
    $('#edit-preview-btns').slideDown();
    $('#email-txt-editor').slideUp();
  }

  function update_stats(stats) {
    $('#n_pending').text(stats.n_pending);
    $('#n_in_transit').text(stats.n_in_transit);
    $('#n_rejected').text(stats.n_rejected);
    $('#n_bounces').text(stats.n_bounces);
    $('#n_complaints').text(stats.n_complaints);
    $('#n_opt_out_both').text(stats.n_opt_out_both);
    $('#n_delivered').text(stats.n_delivered);
    $('#n_opens').text(stats.n_opens);
    $('#n_unique_opens').text(stats.n_unique_opens);
    $('#n_visits').text(stats.n_visits);
    $('#n_unique_visits').text(stats.n_unique_visits);
    $('.n_votes').text(stats.n_votes);
    $('#n_not_voted').text(stats.n_not_voted);
    $('#n_disabled').text(stats.n_disabled);
  }

  function get_stats() {
    $.get('/ajax/' + eid + '/voter-stats').done(update_stats);
    $('#refresh-stats-btn').prop('disabled', true);
    setTimeout(
      function() { $('#refresh-stats-btn').prop('disabled', false) },
      5000);
  };

  my.init = function() {
    eid = $('#data-eid').data('eid');
    // refresh stats
    $('#refresh-stats-btn').click(get_stats);
    // email text update
    $('#email-txt-editor').hide();
    $('#edit-email-txt-btn').click(show_email_txt_editor);
    $('#cancel-email-txt-btn').click(email_txt_editor_cancel);
  };

  return my;
}());

var manage_end = globalThis.manage_end = (function() {

  var my = {};

  my.init = function() {
  };

  return my;
}());

//
// Manage count pages
//

var manage_count = globalThis.manage_count = (function() {

  var my = {};
  var eid;
  var $start_dlg;

  function withdraw_candidates_dlg(data) {
    var candidates = data['candidates'];
    var withdrawn = data['withdrawn'];
    // If candidates exist, then show withdraw dialog
    if (candidates.length) {
      var title = 'Withdraw candidates';
      var html = '<p>Check candidates to withdraw them:</p>';
      for (var i = 0; i < candidates.length; i++) {
        html += '<div class="checkbox"><label>';
        if (withdrawn.indexOf(i) != -1) {
          html += '<input type="checkbox" checked>';
        } else {
          html += '<input type="checkbox">';
        }
        html += candidates[i];
        html += '</label></div>';
      }
      var buttons = {
        'Cancel': 'class="btn btn-default" data-dismiss="modal"',
        'OK': 'class="btn btn-primary" id="ok-dlg-btn"'
      };
      var $dlg = opavote_dlg.dlg('modal-sm', html, title, buttons);
      $dlg.on('click', '#ok-dlg-btn', function() {
        // Get list of checked candidates
        var checkboxes = $dlg.find('input:checkbox');
        var withdrawn = [];
        for (var i = 0; i < checkboxes.length; i++) {
          if ($(checkboxes[i]).is(':checked')) {
            withdrawn.push(i);
          }
        }
        $dlg.modal('hide');
        // Send results to server
        $.ajax({type: 'POST',
                url: '/ajax/' + eid + '/set-withdrawn-json',
                data: JSON.stringify(withdrawn),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json'
        });
      });

    // Otherwise, show an error message
    } else {
      opavote_dlg.msg_sm('You need to provide ballots before withdrawing ' +
                         'candidates.');
    }
  }

  my.init = function() {
    eid = $('#data-eid').data('eid');
    // ballot file ajax uploading
    $('#blt-fileupload').fileupload({
      url: '/ajax/' + eid + '/set-ballots',
      dataType: 'json',
      maxNumberOfFiles: 1,
      maxFileSize: 10000000,
      formAcceptCharset: 'utf-8',
      start: function(e) {
        $start_dlg = opavote_dlg.msg_sm(
          'Processing ballots. Please wait for confirmation.');
      },
      done: function(e, data) {
        if (data.result.error) {
          $start_dlg.modal('hide');
          $('#progress .progress-bar').css('width', 0 + '%');
          opavote_dlg.msg_sm(data.result.msg);
        // Save the page so we can prevent updated info
        } else {
          var page = window.location.href;
          window.location.href = page;
        }
      },
      progressall: function(e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        $('#progress .progress-bar').css('width', progress + '%');
      }
    });
    // ballot file ajax appending
    $('#blt-fileappend').fileupload({
      url: '/ajax/' + eid + '/append-ballots',
      dataType: 'json',
      maxNumberOfFiles: 1,
      maxFileSize: 10000000,
      formAcceptCharset: 'utf-8',
      start: function(e) {
        $start_dlg = opavote_dlg.msg_sm(
          'Processing ballots. Please wait for confirmation.');
      },
      done: function(e, data) {
        if (data.result.error) {
          $start_dlg.modal('hide');
          $('#progress .progress-bar').css('width', 0 + '%');
          opavote_dlg.msg_sm(data.result.msg);
        // Save the page so we can prevent updated info
        } else {
          $('button[value="save"]').click();
        }
      },
      progressall: function(e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        $('#progress .progress-bar').css('width', progress + '%');
      }
    });
    // withdraw candidates
    $('#withdraw-cand-btn').click(function() {
      $.get('/ajax/' + eid + '/get-withdrawn-json', withdraw_candidates_dlg,
            'json');
    });
  };

  return my;
}());

//
// Ballot editing dialog
//
var ballot_editor = globalThis.ballot_editor = (function() {

  var eid;
  var $ballot_editor_template;
  var blt;
  var n_ballots;
  var $rankings;
  var $weight;
  var current_blt;
  var my = {};

  function dedupe(in_array) {
    var out_array = [];
    var tmp = {};
    for (var i = 0; i < in_array.length; i++) { tmp[in_array[i]] = 1; }
    for (i in tmp) { out_array.push(i); }
    return out_array;
  }

  function manage_editing(ballots) {
    // Store the ballot data received from the server.  If we don't have
    // candidates, then prompt the user to enter them.  Otherwise, go to
    // the ballot editing dialog.
    blt = ballots; // data from server
    n_ballots = blt.ballots.length;
    // If no ballots, add an empty one.  We need something to display.
    if (n_ballots == 0) {
      blt.ballots.push({weight: 1, vote: []});
      n_ballots += 1;
    }
    current_blt = 0;
    if (blt.candidates.length) {
      blt_edit_dlg();
    } else {
      candidate_dlg();
    }
  }

  function candidate_dlg() {
    var title = 'Enter ballot file';
    var html = '<p>Enter candidate names, one per line. You cannot change ' +
               'these later so double check before proceeding. Candidate ' +
               'names longer than 20 characters will be truncated.</p>';
    html += '<textarea style="width:100%;" rows=10></textarea>';
    var buttons = {
      'Cancel': 'class="btn btn-default" data-dismiss="modal"',
      'OK': 'class="btn btn-primary" id="ok-dlg-btn"'
    };
    // Show dialog
    var $dlg = opavote_dlg.dlg('', html, title, buttons, undefined, 'textarea');
    var $textarea = $dlg.find('textarea');
    $dlg.on('click', '#ok-dlg-btn', function() {
      // Get candidate list from dlg
      var raw_candidates = $textarea.val().split('\n');
      $dlg.modal('hide');
      // Throw away empty lines and truncate to 20 chars
      var candidates = [];
      for (var i = 0; i < raw_candidates.length; i++) {
        if (raw_candidates[i].length) {
          candidates.push(raw_candidates[i].substr(0, 20));
        }
      }
      // Dedupe and return error if there is a dupe
      var candidates2 = dedupe(candidates);
      if (candidates2.length != candidates.length) {
        opavote_dlg.msg_sm('Error: Two candidates have the same name.');
        return;
      }
      if (candidates.length) {
        blt.candidates = candidates;
        blt_edit_dlg();
      }
    });

  }

  function show_ballot() {
    // Reset the ballot display
    for (var i = 0; i < $rankings.length; i++) {
      $rankings.eq(i).val('');
    }
    // Show rankings for current ballot
    for (var i = 0; i < blt.ballots[current_blt].vote.length; i++) {
      var candidate = blt.ballots[current_blt].vote[i];
      $rankings.eq(candidate).val(i + 1);
    }
    $('#current-blt').text(current_blt + 1);
    $weight.val(blt.ballots[current_blt].weight);
  }

  function first_ballot() {
    current_blt = 0;
    show_ballot();
  }

  function next_ballot() {
    if (current_blt < n_ballots - 1) {
      current_blt += 1;
      show_ballot();
    }
  }

  function previous_ballot() {
    if (current_blt > 0) {
      current_blt -= 1;
      show_ballot();
    }
  }

  function last_ballot() {
    current_blt = n_ballots - 1;
    show_ballot();
  }

  function clear_ballot() {
    for (var i = 0; i < $rankings.length; i++) {
      $rankings.eq(i).val('');
    }
    blt.ballots[current_blt].weight = 1;
    blt.ballots[current_blt].vote = [];
  }

  function delete_ballot() {
    if (n_ballots > 1) {
      blt.ballots.splice(current_blt, 1);
      n_ballots -= 1;
      $('#blt-n-ballots').text(n_ballots);
      if (current_blt === n_ballots) { current_blt -= 1 }
      show_ballot();
    }
  }

  function insert_ballot() {
    blt.ballots.splice(current_blt, 0, {weight: 1, vote: []});
    n_ballots += 1;
    $('#blt-n-ballots').text(n_ballots);
    show_ballot();
  }

  function append_ballot() {
    blt.ballots.push({weight: 1, vote: []});
    n_ballots += 1;
    $('#blt-n-ballots').text(n_ballots);
    current_blt = n_ballots - 1;
    show_ballot();
  }

  function row_click(e) {
    var row = $(e.currentTarget).index() - 1; // Account for header row
    if ($rankings.eq(row).val()) {
    // If there is a ranking already, then remove it
      var candidate_index = $.inArray(row, blt.ballots[current_blt].vote);
      blt.ballots[current_blt].vote.splice(candidate_index, 1);
      show_ballot();
    } else {
      // If not, then add this candidate to the ballot
      // Find the number of rankings already on the ballot
      var n_ranked = $rankings.filter(function() {
        return this.value.length !== 0;
      }).length;
      // Set the clicked on row to the next ranking
      $rankings.eq(row).val(n_ranked + 1);
      // Update the ballot
      blt.ballots[current_blt].vote.push(row);
    }
  }

  function store_weight(e) {
    w = parseInt($weight.val(), 10);
    if (isNaN(w) || w < 1) { w = 1 }
    blt.ballots[current_blt].weight = w;
  }

  function save_ballots_callback(data) {
    var $dlg = opavote_dlg.msg_sm(data.msg);
    $('#n-total-ballots').text(data.n_total_ballots);
    $('#n-votes').text(data.n_votes);
    $('#n-cand').text(data.n_cand);
    $('#price').text(data.price);
    if (!data.can_edit) {
      $('#blt-edit-btn').prop('disabled', true);
    } else {
      $('#blt-edit-btn').prop('disabled', false);
    }
  }

  function blt_edit_dlg() {
    // Create dialog
    var button = {'Save and Exit': 'class="btn btn-primary" id="save-dlg-btn"'};
    var $dlg = opavote_dlg.dlg('modal-lg',
                               $ballot_editor_template.html(),
                               'Ballot Editor',
                               button,
                               {backdrop: 'static', keyboard: false},
                               false);
    // Add data to dialog
    $dlg.find('#blt-n-ballots').text(n_ballots);
    $dlg.find('#blt-title').val(blt.title);
    $dlg.find('#blt-n-winners').val(blt.n_seats);
    var $table = $dlg.find('table#blt-candidates');
    var table_html = '<tr><th>Rank</th><th>Candidate</th></tr>';
    for (var i = 0; i < blt.candidates.length; i++) {
      table_html += '<tr>';
      table_html += '<td><input type="text" size="3" readonly></td>';
      table_html += '<td>' + blt.candidates[i] + '</td>';
      table_html += '</tr>';
    }
    $table.html(table_html);
    $rankings = $table.find('input');
    $weight = $dlg.find('#blt-weight');
    show_ballot();
    // Show dialog and add event handlers
    $dlg.modal('show');
    $dlg.on('change', '#blt-title', function() {
      blt.title = $('#blt-title').val();
    });
    $dlg.on('change', '#blt-n-winners', function() {
      blt.n_seats = $('#blt-n-winners').val();
    });
    $table.on('click', 'tr', row_click);
    $weight.change(store_weight);
    $dlg.on('click', '#blt-delete', delete_ballot);
    $dlg.on('click', '#blt-insert', insert_ballot);
    $dlg.on('click', '#blt-append', append_ballot);
    $dlg.on('click', '#blt-first', first_ballot);
    $dlg.on('click', '#blt-next', next_ballot);
    $dlg.on('click', '#blt-prev', previous_ballot);
    $dlg.on('click', '#blt-last', last_ballot);
    $dlg.on('click', '#blt-clear', clear_ballot);
    $dlg.on('click', '#save-dlg-btn', function() {
      $dlg.modal('hide');
      $.ajax({type: 'POST',
              url: '/ajax/' + eid + '/set-ballots-json',
              data: JSON.stringify({'blt': blt}),
              contentType: 'application/json; charset=utf-8',
              dataType: 'json',
              success: save_ballots_callback});
      });
  }

  my.init = function() {
    eid = $('#data-eid').data('eid');
    // Remove the ballot editor template from the DOM
    $ballot_editor_template = $('#ballot-editor-template').detach();
    // Edit ballots button
    $('#blt-edit-btn').click(function() {
      $.get('/ajax/' + eid + '/get-ballots-json', manage_editing, 'json');
    });
 };

  return my;

}());

//
// Method options
//

var method_options = globalThis.method_options = (function() {

  var my = {};

  function update_options() {
    var method = $('#method').val();
    // These methods have options
    $('#method-options').children().hide();
    if (method == 'Borda Count') {
      $('#ballotCompletion').parent().slideDown();
    } else if (method == 'Instant Runoff Voting') {
      $('#batchElimination').parent().slideDown();
      $('#weakTieBreakMethod').parent().slideDown();
    } else if (method == 'Random Transfer STV') {
      $('#dynamicThreshold').parent().slideDown();
      $('#delayedTransfer').parent().slideDown();
      $('#batchElimination').parent().slideDown();
      $('#weakTieBreakMethod').parent().slideDown();
    } else if (method == 'Fractional Transfer STV') {
      $('#prec').parent().slideDown();
      $('#dynamicThreshold').parent().slideDown();
      $('#fractionalThreshold').parent().slideDown();
      $('#delayedTransfer').parent().slideDown();
      $('#batchElimination').parent().slideDown();
      $('#weakTieBreakMethod').parent().slideDown();
    } else if (/^Meek STV|Warren STV$/.test(method)) {
      $('#prec').parent().slideDown();
      $('#dynamicThreshold').parent().slideDown();
      $('#fractionalThreshold').parent().slideDown();
      $('#weakTieBreakMethod').parent().slideDown();
    }
  }

  my.init = function() {
    // disable separators in select boxes
    $('[value^="\u2550"]').attr('disabled', true);
    // Want to hide all options before showing the option row to reduce
    // animiations on page load.
    $('#method-options').children().hide();
    $('#method-options').show();
    // Update options on method change
    update_options();
    $('#method').change(update_options);
  };

  return my;
}());

globalThis.configure_trix_editor = function configure_trix_editor() {
  document.addEventListener('trix-before-initialize', function(event) {
    Trix.config.toolbar.getDefaultHTML = function() {
      // Modified version of default toolbar in https://github.com/basecamp/trix/blob/main/src/trix/config/toolbar.js
      // Removes attachment and undo/redo buttons
      const lang = Trix.config.lang;
      return `<div class="custom-trix-button-row">
      <span class="trix-button-group trix-button-group--text-tools" data-trix-button-group="text-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-bold" data-trix-attribute="bold" data-trix-key="b" title="${lang.bold}" tabindex="-1">${lang.bold}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-italic" data-trix-attribute="italic" data-trix-key="i" title="${lang.italic}" tabindex="-1">${lang.italic}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-strike" data-trix-attribute="strike" title="${lang.strike}" tabindex="-1">${lang.strike}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-link" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="${lang.link}" tabindex="-1">${lang.link}</button>
      </span>

      <span class="trix-button-group trix-button-group--block-tools" data-trix-button-group="block-tools">
        <button type="button" class="trix-button trix-button--icon trix-button--icon-quote" data-trix-attribute="quote" title="${lang.quote}" tabindex="-1">${lang.quote}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-code" data-trix-attribute="code" title="${lang.code}" tabindex="-1">${lang.code}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-bullet-list" data-trix-attribute="bullet" title="${lang.bullets}" tabindex="-1">${lang.bullets}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-number-list" data-trix-attribute="number" title="${lang.numbers}" tabindex="-1">${lang.numbers}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-decrease-nesting-level" data-trix-action="decreaseNestingLevel" title="${lang.outdent}" tabindex="-1">${lang.outdent}</button>
        <button type="button" class="trix-button trix-button--icon trix-button--icon-increase-nesting-level" data-trix-action="increaseNestingLevel" title="${lang.indent}" tabindex="-1">${lang.indent}</button>
      </span>
    </div>

    <div class="trix-dialogs" data-trix-dialogs>
      <div class="trix-dialog trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">
        <div class="trix-dialog__link-fields">
          <input type="url" name="href" class="trix-input trix-input--dialog" placeholder="${lang.urlPlaceholder}" aria-label="${lang.url}" required data-trix-input>
          <div class="trix-button-group">
            <input type="button" class="trix-button trix-button--dialog" value="${lang.link}" data-trix-method="setAttribute">
            <input type="button" class="trix-button trix-button--dialog" value="${lang.unlink}" data-trix-method="removeAttribute">
          </div>
        </div>
      </div>
    </div>`
    }
  });
}

configure_trix_editor();
